import { render } from "./IndividualPersonalDetails.vue?vue&type=template&id=6083d504&scoped=true"
import script from "./IndividualPersonalDetails.vue?vue&type=script&lang=js"
export * from "./IndividualPersonalDetails.vue?vue&type=script&lang=js"

import "./IndividualPersonalDetails.vue?vue&type=style&index=0&id=6083d504&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6083d504"

export default script